import React, { useContext, useEffect, useRef, useState } from "react";
import "./mob_search.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useNavigate } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import { Form } from "react-bootstrap";
import { Context } from "../../../utils/context";
import { Products } from "../../../utils/apis/Product/Product";

const Mob_search = () => {
  const [show, toggleShow] = useState(false);
  const { productName, setProductName } = useContext(Context);
  const handleInputChange = (event) => {
    setProductName(event.target.value);
  };

  const navigate = useNavigate();
  const handleInputChangesearch = (name) => {
    setProductName(name);
    navigate("/product");
    // setProductName('');
  };
  const [category, setCategory] = useState();
  const GetAllproduct = async () => {
    const response = await Products(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      productName
    );

    if (response?.success) {
      setCategory(response?.data);
    }
  };
  useEffect(() => {
    GetAllproduct();
  }, [productName]);

  console.log(productName, "productName productName");

  console.log(category, "category category");
  return (
    <>
      <div className="searchformob">
        <div className="d-flex">
          <Link className="my-auto" to={"/home"}>
            <FontAwesomeIcon
              className="backscreen"
              icon="fa-solid fa-chevron-left"
            />
          </Link>
          <input
            onClick={() => toggleShow(!show)}
            type="search"
            className="form-control mobileSearch"
            placeholder="Search here..."
            value={productName}
            onChange={handleInputChange}
          />
        </div>

        {show && (
          <ListGroup className="listgroup">
            {category?.data?.map((val) => (
              <ListGroup.Item
                key={val?.id}
                onClick={() => handleInputChangesearch(val?.name)}
              >
                {val?.name}
              </ListGroup.Item>
            ))}

            {/* <ListGroup.Item>Product 2</ListGroup.Item>
            <ListGroup.Item>Product 3</ListGroup.Item>
            <ListGroup.Item>Product 4</ListGroup.Item>
            <ListGroup.Item>Product 5</ListGroup.Item> */}
          </ListGroup>
        )}
      </div>
    </>
  );
};

export default Mob_search;
